import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Typography, makeStyles } from '@material-ui/core';
import moment from 'logic/moment';

export const DEADLINE_ACTIVE_STATUSES = ['pending_host', 'pending_guest'];

const useStyles = makeStyles((theme) => ({
  urgent: {
    color: theme.palette.warning.main,
  },
}));

const ComplaintDeadline = ({ complaint, view }) => {
  const classes = useStyles();

  if (!complaint.deadline_at || !DEADLINE_ACTIVE_STATUSES.includes(complaint.status)) {
    return null;
  }

  const deadline = moment(complaint.deadline_at);
  const isUrgent = moment().isAfter(deadline.clone().subtract(6, 'hours'));
  const isMyTurn =
    (view === 'host' && complaint.status === 'pending_host') ||
    (view === 'guest' && complaint.status === 'pending_guest');

  return (
    <Typography
      variant="caption"
      className={isUrgent ? classes.urgent : undefined}
      component="span"
    >
      {isMyTurn ? (
        <FormattedMessage
          id="complaints.respondBy"
          defaultMessage="Respond by {deadline}"
          values={{ deadline: deadline.calendar() }}
        />
      ) : (
        <FormattedMessage
          id="complaints.responseExpectedBy"
          defaultMessage="Response expected by {deadline}"
          values={{ deadline: deadline.calendar() }}
        />
      )}
    </Typography>
  );
};

ComplaintDeadline.propTypes = {
  complaint: PropTypes.shape({
    deadline_at: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  view: PropTypes.oneOf(['guest', 'host']),
};

export default ComplaintDeadline;
